import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

import { organizationFormError } from '../../../../variables';

export const schemaOrganization = z.object({
  name: z.string().min(1, organizationFormError.name.empty),
  stars: z.number().min(0).max(5).default(0),
  owner: z.string().min(1, 'Owner is required'),
  isTestMode: z.boolean().default(false),
  test_expiration_date: z.date().optional().nullable(),
});

export type OrganizationEntity = z.infer<typeof schemaOrganization>;

const organizationResolver: Resolver<OrganizationEntity> = zodResolver(schemaOrganization) as never;

export const organizationFormOptions: UseFormProps<OrganizationEntity> = {
  mode: 'onSubmit',
  resolver: organizationResolver,
};
